import { t9n } from '../../lib/translate';
import { TS } from '../../config/translation-keys';



const translate_texts = () => {
  let labels = {
    first_name: t9n(TS.REGISTER_LABEL_FIRST_NAME),
    last_name: t9n(TS.REGISTER_LABEL_LAST_NAME),
    select_language: t9n(TS.MENU_LABEL_SELECTLANG),
    bank_account_number: null,
    tax: null,
    ssn: null,
    area_code: null,
    phone_number: null,
    worker_type: null,
    short_description: null,
    video_presentation: null,
    linkedin_profile: null,
    referee: null,
    organization_type: null,
    company_name: null,
    cv_public: null,
    change_password: null,
    btn_next: null,
    btn_close: null,
    btn_upload: null,
    btn_update: null,
    dialog_label: null,
    invalid_bank: null,
    invalid_ssn: null,
    invalid_tax: null,
    invalid_video: null,
    invalid_linkedin: null,
    registration_number: null,
    invalid_first_name: null,
    invalid_last_name: null,
    invalid_img: null,
    invalid_reg_num: null,
    invalid_company_name: null,
    change_pic: null,
    edit_prof: null,
    success_message: null,
    change_password_title: null,
    change_password_label: null,
    old_password_label: null,
    new_password_label: null,
    confirm_password_label: null,
    cancel_label: null,
    delete_acc: null,
    org_type_invalid: null,
    payment_info: null,
    rewatch_tutorial: null,
  };

  labels.autosave = t9n(TS.NEW_ORDER_AUTO_SAVE);
  labels.bank_account_number = t9n(TS.SETTINGS_LABEL_BANK_ACC);
  labels.tax = t9n(TS.SETTINGS_LABEL_TAX);
  labels.ssn = t9n(TS.SETTINGS_LABEL_SSN);
  labels.area_code = t9n(TS.PHONE_AREA_CODE);
  labels.phone_number = t9n(TS.PROFILE_PHONE_NUMBER_LABEL);
  labels.worker_type = t9n(TS.SETTINGS_LABEL_WORKER_TYPE);
  labels.short_description = t9n(TS.SETTINGS_LABEL_SHORT_DESC);
  labels.video_presentation = t9n(TS.SETTINGS_LABEL_VIDEO_PRES);
  labels.linkedin_profile = t9n(TS.PROFILE_LINKEDIN_LINK_LABEL);
  labels.referee = t9n(TS.PROFILE_REFEREE_LABEL);
  labels.organization_type = t9n(TS.SETTINGS_LABEL_ORGANIZATION);
  labels.company_name = t9n(TS.SETTINGS_LABEL_COMPANY);
  labels.cv_public = t9n(TS.SETTINGS_LABEL_CV);
  labels.registration_number = t9n(TS.WORKER_COMPANY_REGISTRATION_NUMBER);
  labels.change_password = t9n(TS.SETTINGS_LABEL_CHANGE_PW);
  labels.btn_next = t9n(TS.TABLE_BUTTON_NEXT);
  labels.btn_close = t9n(TS.LOGIN_FORM_CLOSE);
  labels.btn_upload = t9n(TS.SETTINGS_LABEL_UPLOAD_IMG);
  labels.btn_update = t9n(TS.SETTINGS_LABEL_UPDATE);
  labels.dialog_label = t9n(TS.SETTINGS_LABEL_UPDATE_DIALOG);
  labels.invalid_bank = t9n(TS.SETTINGS_INVALID_BANK);
  labels.invalid_ssn = t9n(TS.SETTINGS_INVALID_SSN);
  labels.invalid_tax = t9n(TS.SETTINGS_INVALID_TAX);
  labels.invalid_video = t9n(TS.SETTINGS_INVALID_VIDEO);
  labels.invalid_linkedin = t9n(TS.SETTINGS_INVALID_LINKEDIN);
  labels.invalid_first_name = t9n(TS.SETTINGS_INVALID_FIRST_NAME);
  labels.invalid_last_name = t9n(TS.SETTINGS_INVALID_LAST_NAME);
  labels.invalid_img = t9n(TS.SETTINGS_LABEL_INVALID_IMG);
  labels.invalid_reg_num = t9n(TS.SETTINGS_LABEL_INVALID_REG_NUM);
  labels.invalid_company_name = t9n(TS.SETTINGS_LABEL_INVALID_COMP_NAME);
  labels.change_pic = t9n(TS.SETTINGS_LABEL_CHANGE_PIC);
  labels.edit_prof = t9n(TS.SETTINGS_LABEL_EDIT_PROF);

  labels.change_password_title = t9n(TS.CHANGE_PASSWORD_FORM_TITLE);
  labels.change_password_label = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);
  labels.old_password_label = t9n(TS.CHANGE_PASSWORD_OLD_PASSWORD_LABEL);
  labels.new_password_label = t9n(TS.CHANGE_PASSWORD_NEW_PASSWORD_LABEL);
  labels.confirm_password_label = t9n(TS.REGISTER_LABEL_PASSWORD_CONFIRM);
  labels.cancel_label = t9n(TS.CHANGE_PASSWORD_CANCEL_LABEL);
  labels.success_message = t9n(TS.CHANGE_PASSWORD_SUCCESS_MESSAGE);
  labels.delete_acc = t9n(TS.SETTINGS_DELETE_ACC);
  labels.org_type_invalid = t9n(TS.SETTINGS_ORG_TYPE_INVALID_TXT);
  labels.btn_save = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);
  labels.payment_info = t9n(TS.SETTINGS_PAYMENT_INFO);
  labels.rewatch_tutorial = t9n(TS.TUTORIAL_REWATCH_TUTORIAL);

  return labels;
};

const ProfileInfo = {
  translate_texts
}

export default ProfileInfo;